import * as React from 'react'

import { Input } from '../../../../../Shared'

interface TextFieldProps {
  id: string,
  label: string,
  value?: string | number,
  handleChange: any,
  optional?: boolean,
}

const TextField = ({ id, label, value, handleChange, optional }: TextFieldProps) => (
  <div className="field">
    <label htmlFor={id}>{label}{optional && <span className="optional"> (Optional)</span>}</label>
    <Input
      className="bordered large"
      handleChange={handleChange}
      id={id}
      value={value == null ? '' : String(value)}
    />
  </div>
)

export default TextField
